@if (data()) {
  @if (isDesktop()) {
    <div class="header" iwSort [formControl]="sortControl">
      @for (column of columns(); track column) {
        @if (column.sortable) {
          <div class="column" [class.justify-end]="column.justifyContentEnd">
            <iw-sort [colName]="column.name" [withDefaultIcon]="true">
              {{ column.i18nKey | translate }}
            </iw-sort>
          </div>
        } @else {
          <div
            class="column"
            [class.justify-end]="column.justifyContentEnd"
            [translate]="column.i18nKey"
          ></div>
        }
      }
    </div>

    @if (columns()?.length) {
      <hr class="divider" />
    }
  }

  <div
    class="body"
    #tableBody
    iwInfiniteScroll
    [hasMore]="!!data()?.cursor"
    [isLoading]="isLoading()"
    (scrolled)="loadMore.emit()"
    (scrollInfo)="tableScrolled.emit($event)"
  >
    @for (row of items(); track $index) {
      @if (row.header) {
        <section class="header-row">{{ row.header }}</section>
      }

      @if (isDesktop()) {
        <ng-container
          *ngTemplateOutlet="templateRef(); context: { $implicit: row }"
        ></ng-container>
      } @else {
        <ng-container
          *ngTemplateOutlet="templateMobile(); context: { $implicit: row }"
        ></ng-container>

        @if (divideRows()) {
          <hr class="divider" />
        }
      }
    } @empty {
      @if (!templateEmpty()) {
        <div class="placeholder">
          <fu-icon iconName="not-found" size="32" />
          <h3 class="placeholder-title">
            {{ emptyTitle() || "table.placeholder.notFound.title" | translate }}
          </h3>
          <p class="placeholder-description">
            {{
              emptyMessage() || "table.placeholder.notFound.description"
                | translate
            }}
          </p>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="templateEmpty()"></ng-container>
      }
    }
  </div>
} @else {
  <div class="body">
    <iw-shimmer [count]="columns().length" [height]="isDesktop() ? 48 : 106" />
  </div>
}
